export class Acesso {
    cpf : string = '';
    inscricao : string = '';
    candidatoInscrito : boolean = false;
    ind_prazoConcurso : string = '';
}
